import { render, staticRenderFns } from "./MenuCarouselmage.vue?vue&type=template&id=39590d7a&scoped=true"
import script from "./MenuCarouselmage.vue?vue&type=script&lang=js"
export * from "./MenuCarouselmage.vue?vue&type=script&lang=js"
import style0 from "./MenuCarouselmage.vue?vue&type=style&index=0&id=39590d7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39590d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39590d7a')) {
      api.createRecord('39590d7a', component.options)
    } else {
      api.reload('39590d7a', component.options)
    }
    module.hot.accept("./MenuCarouselmage.vue?vue&type=template&id=39590d7a&scoped=true", function () {
      api.rerender('39590d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/MenuCarouselmage.vue"
export default component.exports